import { Outlet } from 'react-router-dom';

/**
 * Layout das rotas de autenticacao (`/welcome`, `/login`, `/register`, etc).
 * Wrapper minimal: cada tela controla sua propria largura e composicao
 * interna (algumas — como welcome — sao full-viewport split; outras —
 * forgot, reset — usam um shell centralizado de 420px).
 */
export function AuthLayout() {
  return (
    <main className="min-h-screen bg-canvas" data-testid="auth-layout">
      <Outlet />
    </main>
  );
}
